export default "__VITE_ASSET__dc72a73a__"